import { Link } from '@on3/ui-lib/components/Link';
import { useDynamicRoute } from '@on3/ui-lib/utils/hooks/useDynamicRoute';

import styles from './Nav.module.scss';

const TeamRosterInternalMenu = (
  college: string,
  sport: string,
  year: string,
  /**To account for being a year behind other lists */
  isRoster?: boolean,
) => {
  const rosterYear = isRoster ? year : +year - 1;
  const commitYear = isRoster ? +year + 1 : year;
  const basePath = `/college/${college}/${sport}/${commitYear}`;

  return [
    {
      key: 1,
      name: 'all',
      href: `${basePath}/industry-comparison-commits/`,
      activeMatch: ['/industry-comparison-commits/', '/commits/'],
    },
    {
      key: 2,
      name: 'signed',
      href: `${basePath}/commits/?status=signed`,
      activeMatch: ['?status=signed'],
    },
    {
      key: 3,
      name: 'enrolled',
      href: `${basePath}/commits/?status=enrolled`,
      activeMatch: ['?status=enrolled'],
    },
    {
      key: 4,
      name: 'transfers',
      href: `/college/${college}/${sport}/${commitYear}/transfers/`,
      activeMatch: ['transfer'],
    },
    {
      key: 5,
      name: 'roster',
      href: `/college/${college}/${sport}/${rosterYear}/roster/`,
      activeMatch: ['roster'],
    },
  ];
};

export const InterestsNav = () => {
  const { router, routeParams, routeQuery } = useDynamicRoute();

  const { college, sport, year } = routeParams;
  const status = routeQuery.status;
  const isRoster = router.asPath.includes('roster');
  const list = TeamRosterInternalMenu(college, sport, year, isRoster);

  return (
    <nav className={styles.block}>
      {list.map((item) => {
        let isActive = false;

        if (item.name === 'all') {
          isActive =
            !status && item.activeMatch.some((m) => router.asPath.includes(m));
        } else {
          isActive = item.activeMatch.some((m) => router.asPath.includes(m));
        }

        return (
          <Link
            className={styles.item}
            data-active={isActive}
            href={item.href}
            key={item.key}
          >
            {item.name}
          </Link>
        );
      })}
    </nav>
  );
};
